<template>
    <div class="about-au">
      <p class="indent size-33">OVER 45 YEARS OF EXPERIENCE IN THE PRODUCTION OF ALUMINIUM ROLLED AND
        EXTRUDED PRODUCTS</p>

        <h3 class="indent">Company Profile</h3>
      <p class="indent">
        Alcomet AD is a leading Bulgarian manufacturer of flat-rolled and extruded aluminium products, with more than 45 years of experience in aluminium manufacturing. Based in Shumen, Bulgaria, our integrated production site covers the entire manufacturing process — from billet and coil casting to rolling, extrusion, surface treatment, and precision fabrication. With advanced technologies and a total production capacity of 160,000 tonnes per year, we deliver aluminium solutions for demanding applications worldwide.


      </p>
      <h3 class="indent">Serving Global Markets</h3>
      <p class="indent">
        Alcomet has a strong presence across Europe and the USA, serving customers in Building & Construction, Automotive, Transportation, Packaging, Engineering, and Distribution sectors.
        The company is consistently ranked among Bulgaria’s top 100 companies by revenue and growth, and among the country’s top 100 employers.

      </p>

      <h3 class="indent">Quality, Sustainability & Standards</h3>
      <p class="indent">Quality, environmental responsibility and operational excellence are integral to our manufacturing approach. Alcomet is certified to ISO 9001, ISO 14001, ISO 45001, EN 15088, EN 27001, IATF 16949, QUALANOD, QUALICOAT, and ASI Performance Standard V2, alongside other applicable industry standards.
        </p>
      <p class="indent">
        Continuous investment in technology, people, and sustainable manufacturing enables us to improve product quality, increase resource efficiency, and create long-term value for our customers and partners.
      </p>

      <p class="indent" style="text-align:center;">
        <img class="w-100" v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/0309_achenbah.jpg" alt="">
      </p>
      <p class="indent" style="text-align:center;">
        <img class="w-100" v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/au/0309_presezzi.jpg" alt="">
      </p>

      <h3 class="indent">Strategic Investment & Technology Expansion</h3>
      <p class="indent">The 2023–2026 investment programme, valued at approximately EUR 70 million, has further strengthened our production capabilities and technological potential.</p>
      <p class="indent">
        Key investments include a new ACHENBACH OPTIMILL® 4-HIGH NONREVERSING BATTERY FOIL ROLLING MILL, expanding our expertise in battery foil and other advanced aluminium foil applications, and a new 40 MN PRESEZZI extrusion line equipped with an energy-saving system, enabling the production of larger and more complex profiles.</p>
      <p class="indent">
        Together, these investments enhance our flexibility, efficiency, and technological capabilities, supporting the development of advanced aluminium solutions for industrial, packaging, energy, automotive, and other demanding markets.
      </p>

      <p class="indent" style="text-align:center;">
        <img v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/v1.jpg" alt="">
      </p>
      <p class="indent" style="text-align:center;">
        <img v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/au/v2.jpg" alt="">
      </p>

      <!--
              <div class="about-au-img">
                  <img v-scroll-reveal.reset src="/static/img/about/au/1.jpg" alt="">
                  <img v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/2.jpg" alt="">
                  <img v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/au/3.jpg" alt="">
                  <p v-scroll-reveal.reset="{ delay: 750 }" class="about-au-img-p"></p>
              </div>
              <p class="indent"></p>
              <iframe width="560" height="500" src="https://www.youtube.com/embed/kOaJrBzodvg" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
              -->
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.w-100 { max-width:100%;}
.size-33 { font-size:35px !important; line-height: 54px; text-indent: inherit; text-align: left !important; padding-bottom:30px;}
h3  {
  text-decoration: underline;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
  font-size:24px;
}
.about-au p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-au-img {
  align-items: center;
  display: flex;
  margin: 40px auto;
  position: relative;
  width: 80%;
  padding-right: 10%;
}
.about-au-img img {
  border-radius: 6px;
  height: auto;
  margin-left: 22px;
  width: calc(33.33% - 22px);
}
.about-au img:last-child {
  padding-right: 0;
}
.about-au-img-p {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  font-size: 24px;
  font-weight: 700;
  height: 170px;
  justify-content: center !important;
  text-align: center !important;
  padding: 20px 20px 20px 60px;
  position: absolute;
  right: 0;
  top: calc(50% - 85px);
}
iframe {
  display: block;
  margin: 0 auto;
  width: 60%;
}
@media screen and (max-width: 1280px) {
  .about-au .about-au-img-p {
    font-size: 16px;
  }
}
@media screen and (max-width: 1000px) {
  .about-au p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-au-img {
    flex-wrap: wrap;
    margin-bottom: 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-au-img img {
    margin-left: 20px;
    width: calc(33.33% - 13.33px);
  }
  .about-au-img img:first-child {
    margin-left: 0;
  }
  .about-au .about-au-img-p {
    font-size: 12px;
    font-weight: 500;
    height: initial;
    line-height: 20px;
    position: static;
    top: initial;
  }
  iframe {
    width: 100%;
    padding: 10px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/AboutUs.vue